import React, { useState } from 'react'
import { 
  Layout, 
  Menu, 
  Breadcrumb, 
  Typography, 
  Button,
  Space
} from 'antd'
import { 
  BookOutlined, 
  FolderOutlined, 
  SettingOutlined,
  FileSearchOutlined,
  DatabaseOutlined,
  UploadOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined
} from '@ant-design/icons'
import { Link, Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import BookManagement from '../components/Admin/BookManagement'
import CategoryManagement from '../components/Admin/CategoryManagement'
import FieldManagement from '../components/Admin/FieldManagement'
import PageGeneration from '../components/Admin/PageGeneration'
import SystemStats from '../components/Admin/SystemStats'
import BatchImport from '../components/Admin/BatchImport'
import './Admin.css'

const { Header, Sider, Content } = Layout
const { Title } = Typography

function AdminPanel() {
  const [collapsed, setCollapsed] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  
  const menuItems = [
    {
      key: '/admin/books',
      icon: <BookOutlined />,
      label: <Link to="/admin/books">书籍管理</Link>,
    },
    {
      key: '/admin/import',
      icon: <UploadOutlined />,
      label: <Link to="/admin/import">批量导入</Link>,
    },
    {
      key: '/admin/categories',
      icon: <FolderOutlined />,
      label: <Link to="/admin/categories">分类管理</Link>,
    },
    {
      key: '/admin/fields',
      icon: <SettingOutlined />,
      label: <Link to="/admin/fields">字段管理</Link>,
    },
    {
      key: '/admin/pages',
      icon: <FileSearchOutlined />,
      label: <Link to="/admin/pages">页面生成</Link>,
    },
    {
      key: '/admin/stats',
      icon: <DatabaseOutlined />,
      label: <Link to="/admin/stats">系统统计</Link>,
    },
  ]
  
  const getPageTitle = () => {
    const currentMenu = menuItems.find(item => 
      location.pathname.startsWith(item.key)
    )
    return currentMenu ? currentMenu.label.props.children : '后台管理'
  }
  
  const handleLogout = () => {
    // 清除认证信息
    localStorage.removeItem('admin_token')
    navigate('/login')
  }
  
  return (
    <Layout className="admin-layout">
      {/* 侧边栏 */}
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        className="admin-sider"
      >
        <div className="logo">
          <BookOutlined className="logo-icon" />
          {!collapsed && (
            <span className="logo-text">五千年文库</span>
          )}
        </div>
        
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          className="admin-menu"
        />
      </Sider>
      
      <Layout>
        {/* 头部 */}
        <Header className="admin-header">
          <div className="header-left">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className="trigger"
            />
            <Breadcrumb className="admin-breadcrumb">
              <Breadcrumb.Item>
                <Link to="/">首页</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>后台管理</Breadcrumb.Item>
              <Breadcrumb.Item>{getPageTitle()}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          
          <div className="header-right">
            <Space>
              <Button 
                type="text" 
                icon={<LogoutOutlined />}
                onClick={handleLogout}
              >
                退出登录
              </Button>
            </Space>
          </div>
        </Header>
        
        {/* 内容区域 */}
        <Content className="admin-content">
          <div className="admin-content-wrapper">
            <div className="page-header">
              <Title level={3}>{getPageTitle()}</Title>
            </div>
            
            <div className="admin-routes">
              <Routes>
                <Route path="/books" element={<BookManagement />} />
                <Route path="/books/*" element={<BookManagement />} />
                <Route path="/import" element={<BatchImport />} />
                <Route path="/categories" element={<CategoryManagement />} />
                <Route path="/fields" element={<FieldManagement />} />
                <Route path="/pages" element={<PageGeneration />} />
                <Route path="/stats" element={<SystemStats />} />
                <Route path="/" element={<SystemStats />} />
              </Routes>
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default AdminPanel